const hostUrl = globalThis.location.origin;

export const routes =
  hostUrl === "https://api-qa.lucyrx.com"
    ? {
        UNAUTHORIZED: "/led/ui/unauthorized",
        DASHBOARD: "/led/ui/dashboard",
        COMPANYDASHBOARD: "/led/ui/dashboard/company",
        REQUESTDASHBOARD: "/led/ui/dashboard/request",
        ROLESDASHBOARD: "/led/ui/dashboard/roles",
        LANDING: "/led/ui/landing",
        PROFILE: "/led/ui/dashboard/profile",
        NO_ROLE: "/led/ui/dashboard/no-role",
        NO_ACCESS: "/led/ui/dashboard/no-access",
      }
    : {
        UNAUTHORIZED: "/unauthorized",
        DASHBOARD: "/dashboard",
        COMPANYDASHBOARD: "/dashboard/company",
        REQUESTDASHBOARD: "/dashboard/request",
        ROLESDASHBOARD: "/dashboard/roles",
        LANDING: "/landing",
        PROFILE: "/dashboard/profile",
        NO_ROLE: "/dashboard/no-role",
        NO_ACCESS: "/dashboard/no-access",
      };
